module.exports = __webpack_public_path__ + "img/kwickk-2.8b1e9af5.gif";